import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { FailedSolutions } from './components/FailedSolutions';
import { SystemOverview } from './components/SystemOverview';
import { Timeline } from './components/Timeline';
import { WhatsIncluded } from './components/WhatsIncluded';
import { ForYouSection } from './components/ForYouSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: (...args: any[]) => void;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (!(window as any).fbq) {
      const n: any = (window as any).fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      (window as any)._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
    }
    window.fbq('init', '1436890408218834');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-[#FFF8F0] overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainPoints data-id="element-2" />
      <FailedSolutions data-id="element-3" />
      <SystemOverview data-id="element-4" />
      <Timeline data-id="element-5" />
      <WhatsIncluded data-id="element-6" />
      <ForYouSection data-id="element-7" />
      <FAQSection data-id="element-8" />
      <FinalCTA data-id="element-9" />
      <Footer data-id="element-10" />
    </div>;
}